/*
     Title: Assign Target Table API
     Description: Assign Target Table API
     Author: Iqbal Hossain
     Date: 26-January-2022
     Modified: 26-January-2022
*/

export const ASSIGN_TARGET_API = {
  root: '/api/assign-target',
  fetch_all: 'api/assign-target/fetch-all',
  fetch_by_query: `/api/assign-target/fetch-by-query`,
  fetch_by_id: `/api/assign-target/fetch-by-id`,
  get_by_range: `/api/assign-target/get-range`
};
